import AlbumSubscriptionOption from './AlbumSubscriptionOption';

export default AlbumSubscriptionOption;
